import UibookCase from 'uibook/case'
import React from 'react'
import TelegramChip from '../TelegramChip'

const I18N = {
  ru: {
    before: 'С префиксом',
    after: 'С хвостом',
    both: 'Префикс + хвост',
    long: 'Длинная метка для проверки переноса',
    hintBefore: 'Слот before подходит для иконок.',
    hintAfter: 'Слот after подходит для счетчиков.',
    hintBoth: 'Комбинация before/after для сложных меток.',
    hintLong: 'Проверка поведения с длинным текстом.',
  },
  en: {
    before: 'With prefix',
    after: 'With tail',
    both: 'Prefix + tail',
    long: 'Long chip label for overflow check',
    hintBefore: 'before slot works well for icons.',
    hintAfter: 'after slot works well for counters.',
    hintBoth: 'Combined before/after composition.',
    hintLong: 'Checks long-text behavior.',
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramChipContentClick')
}

export default {
  background: 'light',
  component: TelegramChip,
  i18n: true,
  cases: [
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'elevated',
      before: <span aria-hidden='true'>#</span>,
      description: I18N.en.hintBefore
    }}>{ I18N[locale].before }</UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'mono',
      after: <span aria-hidden='true'>12</span>,
      description: I18N.en.hintAfter
    }}>{ I18N[locale].after }</UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'outline',
      before: <span aria-hidden='true'>@</span>,
      after: <span aria-hidden='true'>NEW</span>,
      description: I18N.en.hintBoth
    }}>{ I18N[locale].both }</UibookCase>,
    locale => <UibookCase props={{
      ...PROPS,
      mode: 'elevated',
      description: I18N.en.hintLong
    }}>{ I18N[locale].long }</UibookCase>
  ]
}
